import { render, staticRenderFns } from "./ForumPost.vue?vue&type=template&id=3db091ba&scoped=true&"
import script from "./ForumPost.vue?vue&type=script&lang=js&"
export * from "./ForumPost.vue?vue&type=script&lang=js&"
import style0 from "./ForumPost.vue?vue&type=style&index=0&id=3db091ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db091ba",
  null
  
)

export default component.exports